import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { lessonDiaryConstants } from '../../constants';
import { lessonDiaryService } from '../../services';
import { notificationActions } from './notification.actions';

const getAll = () => {
  return async (dispatch: any) => {
    const request = () => ({ type: lessonDiaryConstants.GETALL_REQUEST });
    const success = (lessonDiaries: any) => ({ type: lessonDiaryConstants.GETALL_SUCCESS, payload: lessonDiaries });
    const failure = (error: any) => ({ type: lessonDiaryConstants.GETALL_FAILURE, payload: error });

    try {
      const lessonDiaries = await lessonDiaryService.getAll();
      dispatch(success(lessonDiaries));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };
};

const getByMonth = (year: number, month: number) => {
  return async (dispatch: any) => {
    const request = () => ({ type: lessonDiaryConstants.GETALL_REQUEST });
    const success = (lessonDiaries: any) => ({ type: lessonDiaryConstants.GETALL_SUCCESS, payload: lessonDiaries });
    const failure = (error: any) => ({ type: lessonDiaryConstants.GETALL_FAILURE, payload: error });

    dispatch(request());
    try {
      const lessonDiaries = await lessonDiaryService.getByMonth(year, month);
      dispatch(success(lessonDiaries));
      return lessonDiaries; // Return data để có thể then() được
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error; // Throw error để catch() được
    }
  };
};

const createLessonDiary = (formData: FormData) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const lessonDiary = await lessonDiaryService.create(formData);
      dispatch(success(lessonDiary));
      dispatch(notificationActions.addNotification('Tạo nhật ký thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request() {
    return { type: lessonDiaryConstants.CREATE_REQUEST };
  }
  function success(lessonDiary: any) {
    return { type: lessonDiaryConstants.CREATE_SUCCESS, payload: lessonDiary };
  }
  function failure(error: any) {
    return { type: lessonDiaryConstants.CREATE_FAILURE, error };
  }
};

const updateLessonDiary = (id: number, formData: FormData) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const updatedLessonDiary = await lessonDiaryService.update(id, formData);
      dispatch(success(updatedLessonDiary));
      dispatch(notificationActions.addNotification('Cập nhật nhật ký thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request() {
    return { type: lessonDiaryConstants.UPDATE_REQUEST };
  }
  function success(lessonDiary: any) {
    return { type: lessonDiaryConstants.UPDATE_SUCCESS, payload: lessonDiary };
  }
  function failure(error: any) {
    return { type: lessonDiaryConstants.UPDATE_FAILURE, error };
  }
};

const deleteLessonDiary = (id: number) => {
  return async (dispatch: any) => {
    dispatch(request(id));

    try {
      await lessonDiaryService.remove(id);
      dispatch(success(id));
      dispatch(notificationActions.addNotification('Xóa nhật ký thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request(id: number) {
    return { type: lessonDiaryConstants.DELETE_REQUEST, payload: id };
  }
  function success(id: number) {
    return { type: lessonDiaryConstants.DELETE_SUCCESS, payload: id };
  }
  function failure(error: any) {
    return { type: lessonDiaryConstants.DELETE_FAILURE, error };
  }
};

const createFlashcardSet = (diaryId: number) => {
  return async (dispatch: any) => {
    try {
      const response = await lessonDiaryService.createFlashcardSet(diaryId);
      return response;
    } catch (error: any) {
      throw error;
    }
  };
};

const updateFlashcardSet = (diaryId: number) => {
  return async (dispatch: any) => {
    try {
      await lessonDiaryService.updateFlashcardSet(diaryId);
    } catch (error: any) {
      throw error;
    }
  };
};

export const lessonDiaryActions = {
  getAll,
  getByMonth,
  createLessonDiary,
  updateLessonDiary,
  deleteLessonDiary,
  createFlashcardSet,
  updateFlashcardSet,
};
